<script setup>
    // child component of ContactPersonInfo. Shows existing information.

    import { ref, watchEffect } from 'vue';
    import { getFromAPI, getFullUrl } from '../../functionCollection.js';

    const props = defineProps(['fetchUrl', 'userNumber']);
    defineEmits(['switch-to-edit']);

    const contactPersonInfo = ref(null);

    watchEffect(async () => {
        const url = getFullUrl(props.fetchUrl, props.userNumber);
        contactPersonInfo.value = await getFromAPI(url);
    });

</script>

<template>
    <div class="well">
        <div class="row" v-if="contactPersonInfo">
            <div class="col">
                <p>
                    Name: {{ contactPersonInfo.contact_person_surname }}<br>
                    Vorname: {{ contactPersonInfo.contact_person_firstname }}<br>
                    Email: {{ contactPersonInfo.email }}<br>
                    Telefon: {{ contactPersonInfo.phone }}
                </p>
            </div>
        </div>
        <div class="table-footer right">
            <button class="btn btn-link footer-button" @click="$emit('switch-to-edit')">
                Bearbeiten
                <i class="fas fa-lg fa-pencil-alt"></i>
            </button>
        </div>
    </div>
</template>
